import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-dashboard",
  "use": "icon-dashboard-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-dashboard\"><path d=\"M438.186667 572.928L128.426667 408.746667a79.616 79.616 0 0 1 0-140.672l309.76-164.181334a159.232 159.232 0 0 1 149.12 0l309.76 164.181334a79.616 79.616 0 0 1 0 140.672l-309.76 164.181333a159.232 159.232 0 0 1-149.12 0z\" p-id=\"33021\" /><path d=\"M512 938.666667a183.978667 183.978667 0 0 1-86.101333-21.418667L143.786667 767.744a111.36 111.36 0 0 1 0-196.821333 38.826667 38.826667 0 1 1 36.437333 68.608 33.706667 33.706667 0 0 0 0 59.52l282.026667 149.546666a106.069333 106.069333 0 0 0 99.498666 0l282.026667-149.546666a33.706667 33.706667 0 0 0 0-59.52 38.826667 38.826667 0 1 1 36.437333-68.608 111.36 111.36 0 0 1 0 196.821333l-282.112 149.504A183.978667 183.978667 0 0 1 512 938.666667z\" p-id=\"33022\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/dashboard.svg
// module id = BCGP
// module chunks = 42